import { useTranslation } from "react-i18next";
import { Widgets as WidgetsFeature } from "@/partner/features/widgets";
import { Meta } from "@/shared/components";

export function WidgetsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("widgets.pageTitle")} pageType="Partner" />
      <WidgetsFeature />
    </>
  );
}
